/**
 * @generated SignedSource<<77445a3db2ed21c7eda7450ffc04f268>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type offerCatalogue_Query$variables = {
  first?: number | null;
  tagIds: ReadonlyArray<string>;
  text?: string | null;
};
export type offerCatalogue_Query$data = {
  readonly Admin: {
    readonly Offer: {
      readonly subscribableOffers: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly alreadySubscribed: boolean;
            readonly compatibility: {
              readonly isCompatible: boolean;
              readonly missingElementTypes: ReadonlyArray<string>;
            };
            readonly latestVersion: number;
            readonly offerId: string;
            readonly owner: string;
            readonly title: string;
          };
        } | null> | null;
      };
    };
  };
};
export type offerCatalogue_Query = {
  response: offerCatalogue_Query$data;
  variables: offerCatalogue_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "text"
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminQueryType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OfferAdminSchema",
        "kind": "LinkedField",
        "name": "Offer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
              },
              {
                "kind": "Variable",
                "name": "tagIds",
                "variableName": "tagIds"
              },
              {
                "kind": "Variable",
                "name": "text",
                "variableName": "text"
              }
            ],
            "concreteType": "SubscribableOffersConnection",
            "kind": "LinkedField",
            "name": "subscribableOffers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SubscribableOffersEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SubscribableOffer",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "offerId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "owner",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "latestVersion",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "alreadySubscribed",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ElementCompatibility",
                        "kind": "LinkedField",
                        "name": "compatibility",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isCompatible",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "missingElementTypes",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "offerCatalogue_Query",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "offerCatalogue_Query",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "753702d356b86bab4d6b0b89c2f838f7",
    "id": null,
    "metadata": {},
    "name": "offerCatalogue_Query",
    "operationKind": "query",
    "text": "query offerCatalogue_Query(\n  $first: Int\n  $text: String\n  $tagIds: [ID!]!\n) {\n  Admin {\n    Offer {\n      subscribableOffers(first: $first, text: $text, tagIds: $tagIds) {\n        edges {\n          node {\n            offerId\n            owner\n            title\n            latestVersion\n            alreadySubscribed\n            compatibility {\n              isCompatible\n              missingElementTypes\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a2d826e3340396056a71f023cb696d6d";

export default node;
